import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  itemSection: FelaCSS;
  itemWrap: FelaCSS;
  iconWrap: FelaCSS;
  text: FelaCSS;
}

const styles = (last?: boolean): IStyles => {
  const borderStyle: FelaCSS = {
    ...(!last && {
      borderBottomWidth: '1px',
      borderBottomStyle: 'solid',
      borderBottomColor: colors.space15,
    }),
  };

  return {
    wrapper: {
      ...borderStyle,
      paddingBottom: last ? '0' : '24px',
    },

    itemSection: {
      flexDirection: 'row',
      flexWrap: 'wrap',
    },

    itemWrap: {
      flexShrink: 0,
      flexDirection: 'row',
      alignItems: 'center',
      width: '50%',
      marginTop: '16px',

      maxWidthTabletSm: {
        paddingRight: '8px',
      },

      ':nth-of-type(even)': {
        paddingLeft: '12px',
        paddingRight: '0',

        maxWidthTabletSm: {
          paddingLeft: '8px',
        },
      },
    },

    iconWrap: {
      justifyContent: 'center',
      marginRight: '8px',
      height: '16px',
    },

    text: {
      fontDefault: 14,
      lineHeight: '16px',
      color: colors.space,
    },
  };
};

export default styles;
